export default {
    RECEIVE_RATE_SEASON_CONFIGURATION_OF_HARBOUR: 'RECEIVE_RATE_SEASON_CONFIGURATION_OF_HARBOUR',
};
